import axios from "axios";
import { basename } from "healthex-common/utils";
import JSZip from "jszip";
import { saveAs } from "./FileUtils";
export async function downloadZipFromUrls(urls, filename) {
    const zip = new JSZip();
    await Promise.all(urls.map(async (url) => {
        try {
            const response = await axios.get(url, { responseType: "blob" });
            zip.file(basename(url), response.data);
        }
        catch (e) {
            console.error(`Failed to add file to zip from ${url}`);
        }
    }));
    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, filename);
}
